import { ActionItemStatus, ReliasTraining, ReliasTrainingStatus } from '@uplift/api';

export type TrainingAggregateStatus = 'notStarted' | 'inProgress' | 'completed';

export const getAggregateDisplayStatus = (trainings: ReliasTraining[]): TrainingAggregateStatus => {
  if (!trainings.length) {
    return 'notStarted';
  }

  if (trainings.every((training) => training.status === ReliasTrainingStatus.completed)) {
    return 'completed';
  }

  if (trainings.some((training) => training.status !== ReliasTrainingStatus.notStarted)) {
    return 'inProgress';
  }

  return 'notStarted';
};

export const getCompletedCount = (trainings: ReliasTraining[]) =>
  trainings.filter((training) => training.status === ReliasTrainingStatus.completed).length;

/**
 * The parent to-do is only marked done once every training is completed; a partially
 * completed set must still surface in the main To Do list with per-training CTAs, so this
 * intentionally collapses to a binary status rather than reusing ActionItemStatus.inProgress.
 */
export const getAggregateGateStatus = (trainings: ReliasTraining[]): ActionItemStatus =>
  trainings.length > 0 && trainings.every((training) => training.status === ReliasTrainingStatus.completed)
    ? ActionItemStatus.done
    : ActionItemStatus.todo;
